
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Da gibt es jede Menge Angebote, von der stationären Behandlung bis zur App.
Entspannungsverfahren, Biofeedback oder kognitive Verhaltenstherapie sind etwa
gleich wirksam. Unter den Entspannungsverfahren ist die «Progressive
Muskelrelaxation nach Jacobson» am populärsten, weil sie schnell erlernbar ist
(die kostenlose `}<Link href='https://schmerzklinik.de/die-migraene-app/' mdxType="Link">{`Migräne-App`}</Link>{`
enthält zum Beispiel eine Version). Damit lässt sich die Häufigkeit der Migräne
um 35 bis 45 Prozent reduzieren, also etwa gleich gut wie mit dem vorbeugend
wirkenden Betablocker Propranolol. Am besten plant man täglich mindestens 15
Minuten für das Entspannungstraining ein. Stressbewältigungstraining,
Selbstsicherheitstraining und Sozialkompetenztraining (zum Beispiel, um Nein
sagen zu lernen, wenn das Pensum zu gross wird) sind weitere Möglichkeiten.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;